import moment from "moment";

const adjustMomentTime = dateToAdjustTo => {
    const offset = new Date(dateToAdjustTo).getTime() - Date.now();

    moment.now = () => offset + Date.now();
};

export default adjustMomentTime;
